import React, { useState,useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/ProjectController/CreateProjectController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateProject({project, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ ProjectName: '', IsDefault: '0', ProjectDescription:''});
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (project) {
            setFormData({ ProjectName: project.ProjectName,IsDefault: project.IsDefault, ProjectDescription:project.ProjectDescription });
        } else {
            setFormData({ ProjectName: '', IsDefault: '0', ProjectDescription:'' }); // Clear form data when switching to add mode
        }
    }, [project]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        debugger;
        event.preventDefault(); // Prevent default form submission
        if (project && project.ID != "undefined") {
            formData.ID=project.ID;
          } else {
              formData.ID=0;
          }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
           
            redirectCallback();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            redirectUserList();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };


    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="projectModal" tabIndex="-1" aria-labelledby="projectModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{project ? "Edit Project" : "Add Project"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">



                                <div className="row mb-3" style={{"marginLeft":"5px","marginRight":"0px","marginTop":"10px"}}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Project Name:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="ProjectName" value={formData.ProjectName} onChange={handleFieldChange} />
                                        {errors.ProjectName && <div style={{ color: 'red' }}>{errors.ProjectName}</div>}
                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Is Default?:</label>
                                    <div className="col-sm-4">
                                        <select className='form-control' name="IsDefault" value={formData.IsDefault} onChange={handleFieldChange}>
                                      
                                            <option value="0">No</option>
                                            <option value="1">Yes</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="row mb-3" style={{"marginLeft":"5px","marginRight":"0px"}}>

                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Description:</label>
                                    <div className="col-sm-10">
                                        <input type="text" className="form-control" name="ProjectDescription" value={formData.ProjectDescription} onChange={handleFieldChange} />

                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                <i className="icofont-save" aria-hidden="true"> {project ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button"  data-dismiss="modal" aria-label="Close">
                                <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    );
}

export default CreateProject;